import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-equipment-grp-menu',
  templateUrl: './equipment-grp-menu.component.html',
  styleUrls: ['./equipment-grp-menu.component.css']
})
export class EquipmentGrpMenuComponent implements OnInit {
    equipmentGrpId;

    public menu?: Menu;

    public equipmentGroupNameButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'equipmentgrplang', gotoParms: () => this.menu!.equipmentgrp_id ?? '' }
    ];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.equipmentGrpId = this.stateService.getStateParams()['equipmentgrp_id'];
    }

    private async loadMenu() {
        if (!!this.equipmentGrpId) {
            this.menu = (await this.datatask.Post(2048, { equipmentgrp_id: this.equipmentGrpId }))[0];
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    equipmentgrp_id: string;
    equipmentgrp_name: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('equipmentGrpMenu', {
//        templateUrl: 'views/components/views/equipmentGrpMenu/equipmentGrpMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'equipmentGrpMenuService', function ($stateParams, stateService, equipmentGrpMenuService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let equipmentGrpId = $stateParams.equipmentgrp_id;

//            vm.model = {
//                equipmentGroupNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('equipmentgrplang', { equipmentgrp_id: vm.model.menu.equipmentgrp_id }) }
//                ],
//                menu: {}
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await equipmentGrpMenuService.getMenu({ equipmentgrp_id: equipmentGrpId }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMenu();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
